import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// ========== SCSS ==========
import '../scss/directory.scss';

// ========== ICONS ==========
import tools from '../_assets/images/icons/tools.png';
import docs from '../_assets/images/icons/docs.png';
import graphics from '../_assets/images/icons/graphics.png';
import meeting_big from '../_assets/images/icons/meeting_big.png';
import presentation from '../_assets/images/icons/presentation.png';
import team from '../_assets/images/icons/team.png';
import video from '../_assets/images/icons/video.png';
import workshop from '../_assets/images/icons/workshop.png';

import products from '../_assets/images/icons/products.png';
import meeting_small from '../_assets/images/icons/meeting_small.png';
import photo from '../_assets/images/icons/photo.png';
import list from '../_assets/images/icons/list.png';

export class DirectoryItem extends Component {
  constructor(props) {
    super(props);
  }

  getIconByName(name) {
    let base = window.normalizeString(name);
    if (base.includes('materiais') || base.includes('material'))
      return docs;
    if (base.includes('produto'))
      return products;
    if (base.includes('reunioes'))
      return meeting_small;
    if (base.includes('atas'))
      return meeting_big;
    if (base.includes('foto'))
      return photo;
    if (base.includes('lista'))
      return list;
    if (base.includes('video'))
      return video;
    if (base.includes('apresent') || base.includes('planos'))
      return presentation;
    if (base.includes('oficina'))
      return workshop;
    if (base.includes('equipe'))
      return team;

    return tools;
  }

  getElementsFromContent() {
    let elements = [];

    // directories
    this.props.content.directory_list.forEach((dir, i) => {
      elements.push(
        <Link
          key={i}
          to={'/directory/' + dir.id}
          className="sub-item"
        >
          <h4>{ dir.name }</h4>
        </Link>
      );
    });

    // files
    this.props.content.file_list.forEach((file, i) => {
      elements.push(
        <a
          key={file.id}
          href={window.utils.site_url + 'uploads/' + file.source}
          target="_blank"
          rel="noopener"
          className="sub-item"
        >
          <h4>{ file.name }</h4>
        </a>
      );
    });

    return elements;
  }

  render() {
    switch (this.props.parent_directory.type) {
      case 'states':
        return (
          <Link
            to={'/directory/' + this.props.id}
            className="item"
          >
            <img
              src={ window.location.origin +
                window.utils.base_public_path +
                '/img/flags/' +
                window.normalizeString(this.props.name) +
                '.png'
              }
              onError={(e) => {
                e.onerror = null;
                e.target.src = window.location.origin + window.utils.base_public_path + '/img/flags/default.png';
              }}
            />
            <h3>{ this.props.name }</h3>
          </Link>
        );
      case 'expanded':
        return (
          <div className="item">
            <div className="item-title">
              <img className="icon" src={this.getIconByName(this.props.name)} />
              <Link
                to={'/directory/' + this.props.id}
              >
                <h3>{ this.props.name }</h3>
              </Link>
            </div>
            <div className="sub-content">
              {this.getElementsFromContent()}
            </div>
            <Link
              to={'/registry/file/' + this.props.id}
              className="btn filled"
            >
              Enviar arquivo
            </Link>
          </div>
        );
      default:
        return (
          <Link
            to={'/directory/' + this.props.id}
            className="item"
          >
            <img className="icon" src={this.getIconByName(this.props.name)} />
            <h3>{ this.props.name }</h3>
          </Link>
        );
    }
  }
}

export default DirectoryItem
